import React from "react";
import PropTypes from "prop-types";

import { Router } from "react-router-dom";
import { StaticRouter } from "react-router";
import { createBrowserHistory } from "history";


export default class UniversalRouter extends React.Component {
  constructor(props) {
    super(props);
    this.trackPageview = this._trackPageview.bind(this);

    if (typeof window !== "undefined") {
      this.history = createBrowserHistory(props);
      this.history.listen(this.trackPageview);
    }
  }

  _trackPageview(location) {
    if (location.pathname != "/authorize" && window.ga) {
      window.ga("send", "pageview", { page: location.pathname + location.search });
    }
  }

  render() {
    if (typeof window === "undefined") {
      return (
        <StaticRouter
          location={this.props.path}
          context={this.props.context}
          children={this.props.children}
        />
      );
    } else {
      return <Router
        children={this.props.children}
        history={this.history}
      />;
    }
  }
}

UniversalRouter.propTypes = {
  children: PropTypes.node,
  path: PropTypes.string,
  context: PropTypes.object,
};



// WEBPACK FOOTER //
// ./src/utils/UniversalRouter.js